
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dang-nhap",
      function () {
        return require("private-next-pages/dang-nhap/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dang-nhap"])
      });
    }
  